import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Text = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  cursor: "default",
}));

export const DateRangeText = styled(Text)(() => ({}));

export const StepActionTitle = styled(Text)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  fontWeight: 600,
  letterSpacing: "0.1px",
  maxWidth: "180px",
}));

export const Value = styled(Text)(() => ({
  textOverflow: "ellipsis",
  overflow: "hidden",
}));

const Badge = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: "32px",
  height: "32px",
  borderRadius: "100%",
  padding: "8px",

  position: "relative",
  top: "-2px",
}));

export const BadgeSuccess = styled(Badge)(() => ({
  backgroundColor: colors.success600,
}));

export const BadgeProgress = styled(Badge)(() => ({
  backgroundColor: colors.brandBlue600,
}));

export const BadgePending = styled(Badge)(() => ({
  backgroundColor: colors.gray200,
}));

const Line = styled("div")(() => ({
  width: "1px",
  minHeight: "40px !important",
  height: "100% !important",
  position: "relative",
  left: "16px",
  top: "-2px",
}));

export const LineSuccess = styled(Line)(() => ({
  backgroundColor: colors.success600,
}));

export const LinePending = styled(Line)(() => ({
  backgroundColor: colors.gray200,
}));

export const TitleWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  cursor: "default",
}));

export const Title = styled("p")(() => ({
  fontFamily: "Manrope",
  margin: 0,
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  letterSpacing: "0.15px",
}));

export const TitleSuccess = styled(Title)(() => ({
  color: colors.success600,
}));
export const TitleProgress = styled(Title)(() => ({
  color: colors.brandBlue600,
}));
export const TitlePending = styled(Title)(() => ({
  color: colors.gray500,
}));

export const Box = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "8px",
}));

export const VeticalWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

interface IStyledVeticalWrapperProps {
  gap: string;
  padding?: string;
}

export const StyledVeticalWrapper = styled(VeticalWrapper)(
  ({ gap, padding = "0px" }: IStyledVeticalWrapperProps) => ({
    gap: `${gap}`,
    padding: `${padding}`,
  })
);
